import { HelpdeskTaskPriorityEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk.task.priority.enum';
import { HelpdeskPriorityI18nEnum } from '@zaoblako/shared/modules/helpdesk/i18n/helpdesk.priority.i18n.enum';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { HelpdeskDtoKeyEnum } from '@zaoblako/shared/modules/helpdesk/enum/helpdesk-dto-key.enum';
import { DtoMessageEnum } from '@zaoblako/shared/common/enums/dto.message.enum';
import { commonEnumValidator } from '@zaoblako/shared/modules/serde/validators/common-enum.validator';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { EavCheckersEnum } from '@zaoblako/shared/modules/eav/enums/eav-checkers.enum';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';
import type { EavEntityTypeFindInterface } from '@zaoblako/shared/modules/eav/dtos/entity-type/eav-entity-type-find.dto';

import * as yup from 'yup';

/** HelpDesk task type create/update request body */
export interface HelpdeskTaskTypeFormInterface {
  /** Task type display name */
  name: string;
  /** Helpdesk task will inherit this priority */
  defaultPriority?: HelpdeskTaskPriorityEnum;
  /** Helpdesk task will inherit direction's deadline */
  defaultDeadline?: number;
  /** Related direction */
  direction: DirectionFindInterface;
  /** Related responsible user */
  responsible?: UserFindInterface;
  /** Related user group auditors */
  userGroupAuditors?: UserGroupFindInterface[];
  /** Related EAV entity type which contains additional fields for HD tasks with this task type */
  entityType?: EavEntityTypeFindInterface;
}

/** HelpDesk task type create/update request body - DTO schema */
export const HelpdeskTaskTypeFormDto = SerdeDtoClass.create<HelpdeskTaskTypeFormInterface>(HelpdeskDtoKeyEnum.HELPDESK_TASK_TYPE_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup
      .string()
      .min(1, DtoMessageEnum.EMPTY_STRING),
  },
  defaultPriority: {
    optional: true,
    default: HelpdeskTaskPriorityEnum.MEDIUM,
    label: 'Приоритет заявки по-умолчанию',
    serializer: commonEnumValidator(HelpdeskTaskPriorityEnum, HelpdeskPriorityI18nEnum),
  },
  defaultDeadline: {
    optional: true,
    default: 0,
    label: 'Дедлайн по-умолчанию',
    serializer: yup.number(),
  },
  direction: {
    label: 'БС',
    checkers: [CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  responsible: {
    optional: true,
    label: 'Ответственный',
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
  userGroupAuditors: {
    optional: true,
    label: 'Группы аудиторов',
    checkers: [SecurityBackendValidatorsEnum.USER_GROUP_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
  entityType: {
    optional: true,
    label: 'Шаблон полей',
    checkers: [EavCheckersEnum.EAV_ENTITY_TYPE_ASSERT_EXISTS_BY_DTO],
    serializer: entityLikeSchema,
  },
});
